// Typesense (the sole search engine, DM-2301) joins filter clauses with ` && `; the legacy
// Algolia engine it replaced used ` AND `. These helpers parse a string regardless of which
// syntax authored it, so a stale filter from before the DM-2366/DM-2296 flip — e.g. a
// bookmarked URL — can be normalized to Typesense's syntax instead of being concatenated into
// an invalid mixed `filter_by`.

const CLAUSE_SEPARATOR = /\s+(?:&&|AND)\s+/i;

export const splitFilterClauses = (filters: string): Array<string> =>
  filters
    .split(CLAUSE_SEPARATOR)
    .map((clause) => clause.trim())
    .filter(Boolean);

// Matches a createdAt range clause in either syntax: `createdAt >= N` / `createdAt <= N`
// (legacy Algolia) or `createdAt:>=N` / `createdAt:<=N` (Typesense, the active engine).
export const isCreatedAtClause = (clause: string): boolean => /createdAt\s*:?\s*(?:>=|<=)/i.test(clause);

export const extractDateRangeClauses = (filters: string): Array<string> =>
  splitFilterClauses(filters).filter(isCreatedAtClause);

export const getGlobalSearchFilterClauses = (filters: string): Array<string> =>
  splitFilterClauses(filters).filter((clause) => isCreatedAtClause(clause) || /^trashed\s*:\s*false$/i.test(clause));

// True when a createdAt clause is written in the legacy Algolia ` >= ` syntax, which is invalid
// for Typesense and must be dropped, not preserved — e.g. a bookmarked URL that predates the flip.
export const isForeignCreatedAtClause = (clause: string): boolean => {
  if (!isCreatedAtClause(clause)) {
    return false;
  }
  const isTypesenseSyntax = /createdAt\s*:\s*(?:>=|<=)/i.test(clause);

  return !isTypesenseSyntax;
};
